import { useForm } from "@/form";
import { defineStore } from "pinia";

export const useStore = defineStore("singleModeGenerations", {
    state: () => {
        return {
            generationsData: [],
            pageData: 1,
            processingData: false,
            hasMoreData: true,
        };
    },

    getters: {
        generations: (state) => {
            return state.generationsData;
        },
        page: (state) => {
            return state.pageData;
        },
        processing: (state) => {
            return state.processingData;
        },
        hasMore: (state) => {
            return state.hasMoreData;
        },
    },

    actions: {
        async fetch() {
            if (this.processingData) return;

            try {
                this.processingData = true;
                const response = await useForm({
                    page: this.pageData,
                }).post("single_mode_index");
                this.generationsData.push(...response.data);
                this.hasMoreData = response.next_page_url !== null;
                this.processingData = false;
            } catch (error) {
                return error;
            }
        },

        async refresh() {
            if (this.processingData) return;

            this.pageData = 1;
            this.generationsData = [];
            this.hasMoreData = true;

            await this.fetch();
        },

        async loadMore() {
            if (this.processingData) return;

            if (this.hasMoreData) {
                this.pageData++;

                await this.fetch();
            }
        },

        update(id, data) {
            const index = this.generationsData.findIndex((generation) => generation.id === id);
            this.generationsData[index] = data;
        },
    },
});
